/**
* DataLoader
*/

class DataLoader {
    constructor(options) {
        if(!options || !options.url) return;

        this.debug = (options.debug) ? options.debug : false;
        this.error = (options.error) ? options.error : null;
        this.success = (options.success) ? options.success : null;
        this.type = (options.type) ? options.type : 'json';
        this.url = options.url;

        this.loadData();
    }

    loadData() {
        var that = this;

        if(this.debug) {
            console.log('new DataLoader:');
            console.log('- loadData(' + this.url + ')');
        }

        $.ajax({
            async: true,
            dataType: this.type,
            type: 'get',
            url: this.url,

            success: function(data) {
                if(that.debug) {
                    console.log('- success:', JSON.stringify(data));
                }

                if(that.success) {
                    that.success(data);
                }
            },

            error: function(request, status, error) {
                if(that.debug) {
                    console.log('- error:', status, error);
                }

                if(that.error) {
                    that.error();
                }
            }
        });
    }
}

/**
* DataSender
*/

class DataSender {
    constructor(options) {
        if(!options || !options.url) return;

        this.data = (options.data) ? options.data : {};
        this.debug = (options.debug) ? options.debug : false;
        this.error = (options.error) ? options.error : null;
        this.success = (options.success) ? options.success : null;
        this.type = (options.type) ? options.type : 'json';
        this.url = options.url;

        this.sendData();
    }

    sendData() {
        var that = this;

        if(this.debug) {
            console.log('new DataSender:');
            console.log('- sendData(' + this.url + ', ' + JSON.stringify(this.data) + ')');
        }

        $.ajax({
            async: true,
            data: this.data,
            dataType: this.type,
            method: 'post',
            url: this.url,

            success: function(data) {
                if(that.debug) {
                    console.log('- success:', JSON.stringify(data));
                }

                if(that.success) {
                    that.success(data);
                }
            },

            error: function(request, status, error) {
                if(that.debug) {
                    console.log('- error:', status, error);
                }

                if(that.error) {
                    that.error();
                }
            }
        });
    }
}

export { DataLoader, DataSender }
